export default "__VITE_ASSET__ButXyUsz__"